import * as React from "react";
import {Route, Switch} from "react-router-dom";
import ActiveInsurances from "insurance/components/activeInsurances";
import PolicyTerms from "insurance/components/policyTerms";
import {history} from "load/store";
import FAQ from "insurance/components/faq";
import CategoryList from "insurance/components/categoryList";
import ProductDetails from "insurance/components/products";
import UserDetails from "insurance/forms/userData";
let indexPath = null;

export enum RoutePaths {
    ACTIVE_INSURANCES = "/activeInsurances",
    POLICIES = "/policies",
    CATEGORY_LIST = "/",
    PRODUCT_LIST = "/productList",
    USER_DETAILS = "/userDetails",
    FAQ = "/faq",
}

export function getRoutes(path: string) {
    return (
        <Switch>
            <Route exact path={`${path}`} component={CategoryList}/>
            <Route exact path={`${path}${RoutePaths.PRODUCT_LIST}`} component={ProductDetails}/>
            <Route exact path={`${path}${RoutePaths.USER_DETAILS}`} component={UserDetails}/>
            <Route exact path={`${path}${RoutePaths.ACTIVE_INSURANCES}`} component={ActiveInsurances}/>
            <Route exact path={`${path}${RoutePaths.POLICIES}`} component={PolicyTerms}/>
            <Route exact path={`${path}${RoutePaths.FAQ}`} component={FAQ}/>
        </Switch>
    );
}
export function setIndexPath(path: string) {
    indexPath = path;
}
export let currentPage = "";
export function handleNavigation(navigateToPath) {
    if (indexPath) {
        history.push({pathname: `${indexPath}${navigateToPath}`});
        currentPage = navigateToPath;
    }
}
